/* eslint-disable react/prefer-stateless-function */
import { h, Component } from 'preact';
import style from './style';
import { getPageConfig } from '../../../lib/device';
import cx from 'classnames';
import { getCommonProps } from '../../../lib/page';
import CategoryClusterP25 from '../category-cluster-p25';
import { trackingProvider, DIMENSION, trackProps } from '@cube/track';
@trackingProvider({
	[DIMENSION.componentpath]: 'NewsClusterP25'
})
export default class NewsClusterP25 extends Component {
	//  TODO: last game played

	setActiveTab = (tabId) => {
		this.setState({ activeTab: tabId });
	};
	componentWillMount() {
		this.setActiveTab(this.props?.pageConfig?.clusters?.newsTabs[0]?.id);
		let pageConfig = getPageConfig(this.props?.pageConfig, 'Desktop');
		this.setState({ pageConfig });
	}

	componentDidMount() {}

	render({ width, ...props }, { pageConfig, activeTab }) {
		const tabs = pageConfig?.clusters?.newsTabs;
		return (
			<div class={style.newsCluster}>
				<div class={style.tabsContainer}>
					<div class={cx(style.tabs, style.tabStyleFlip)}>
						<nav>
							<ul>
								{tabs?.map((tab, i) => (
									<li
										key={tab?.id}
										// eslint-disable-next-line react/jsx-no-bind
										onClick={() => this.setActiveTab(tab?.id)}
										class={tab.id === activeTab ? style.tabCurrent : ''}
									>
										<a
											{...trackProps(
												{
													[DIMENSION.contenttitle]: 'Tab-' + tab?.label,
													[DIMENSION.clickindex]: i + 1
												},
												this.context
											)}
										>
											{tab.label}
										</a>
									</li>
								))}
							</ul>
						</nav>
						<div class={style.contentWrap}>
							{tabs?.map(
								(tab) =>
									tab.id === activeTab && (
										<section
											key={tab?.id}
											// eslint-disable-next-line react/jsx-no-bind
											onClick={() => this.setActiveTab(tab?.id)}
										>
											<CategoryClusterP25
												{...tab?.tabContent}
												title={tab?.label}
												qeId={'sc-home-entertainment-' + tab.label}
												width={width}
												{...getCommonProps(props)}
											/>
										</section>
									)
							)}
						</div>
					</div>
				</div>
			</div>
		);
	}
}
